(function($){

	$(document).ready(function(){

		$(document).on('click','.gazoo-grid:not(.no-selection) .gazoo-grid__item .media-container',function(e){
			e.preventDefault();
			$(this).parent().toggleClass('selected');
		});

		$(document).on('click','.gazoo-grid .gazoo-grid__item .media-container .media-container__overlay a',function(e){
			e.stopPropagation();
		});

		$(document).on('click','.grid-actions__menu a', function(e){
			e.preventDefault();
			$gazoo_grid = $(this).parents('.gazoo-grid__container').find('.gazoo-grid');

			if($(this).data('action') == 'select-all') {
				$gazoo_grid.find('.gazoo-grid__item').addClass('selected');
			} else {
				$gazoo_grid.find('.gazoo-grid__item').removeClass('selected');
			}

		});

		$(document).on('click','.download-link',function(e){
			e.preventDefault();
			$target_link = $(this).attr('href');

			if(Cookies.get('copyright_accepted')) {
				window.open($target_link);
			} else {
				$('#copyrightModal').modal('show', $(this));
				return false;
			}
		});

	});
	
})(jQuery);